import { Flex, Skeleton } from '@iheartjane/reefer';

import { ProductsSkeleton } from '@jane/bloom/components/skeletonLoaders/productsSkeleton';
import { RowHeaderSkeleton } from '@jane/bloom/components/skeletonLoaders/rowHeaderSkeleton';

import styles from './featuredPageSkeleton.module.css';

export function FeaturedPageSkeleton() {
  return (
    <main className={styles['mainFeatured']} data-testid="featured-skeleton">
      {/* Products */}
      <RowHeaderSkeleton />
      <ProductsSkeleton />

      {/* Deals */}
      <div className={styles['deals']}>
        <RowHeaderSkeleton productCountVisible={false} />
        <Flex gap={24}>
          {Array.from({ length: 3 }, (_, i) => (
            <Skeleton key={i} animate>
              <Skeleton.Bone className={styles['deal']} />
            </Skeleton>
          ))}
        </Flex>
      </div>
    </main>
  );
}
